import $ from 'jquery';
import CurrencyConverter from 'shopify-currency-converter';
import layout from '../Layout';
import ProductForm from './ProductForm';

export default class ProductMenu {
  constructor(el, data, postMessage, inQuickshop) {
    this.el = el;
    this.$el = $(el);
    this.data = data;

    this.states = {
      selectOptions: 'selectoptions',
      addToCart: 'addtocart',
      addToCartSuccess: 'addtocart-success',
    };

    this.dismissButton = this.el.querySelector('[data-product-menu-slideout-dismiss]');
    this.selectOptionsButton = this.el.querySelector('[data-product-menu-button="selectoptions"]');
    this.addToCartButton = this.el.querySelector('[data-product-menu-button="addtocart"]');

    this.slideout = this.el.querySelector('[data-product-menu-slideout]');
    this.$slideout = $(this.slideout);
    this.defaultDesktopState = this.el.getAttribute('data-product-menu-desktop-default-state');
    this.defaultMobileState = this.el.getAttribute('data-product-menu-mobile-default-state');
    this.currentState = layout.isBreakpoint('L') ? this.defaultDesktopState : this.defaultMobileState;

    // Form
    this.form = new ProductForm(this.$el, {
      product: this.data.product,
      moneyFormat: this.data.money_format,
      postMessage,
      useHistory: !inQuickshop,
      enableCartRedirection: this.data.enable_cart_redirection,
      onSuccess: (response, quantity) => this._onAtcSuccess(response, quantity),
      onError: (response, error) => this._onAtcError(response, error),
      onVariantChange: variant => this._onVariantChange(variant),
      onQuantityChange: (variant, quantity) => this._onQuantityChange(variant, quantity),
    });

    // atc button
    this.$productMenuButtonAddToCartPrice = $(
      '[data-product-menu-button-addtocart-price]',
      this.el,
    );

    // Success and failure elements
    this.$productAtcFailureMessage = $(
      '[data-product-menu-addtocart-failure-message]',
      this.$el,
    );
    this.$productAtcSuccessMessage = $(
      '[data-product-menu-addtocart-success-message]',
      this.$el,
    );
    this.$productAtcSuccessMessageVariantQuantity = $(
      '[data-product-menu-addtocart-success-quantity]',
      this.$el,
    );
    this.$productAtcSuccessMessageProductTitle = $(
      '[data-product-menu-addtocart-success-title]',
      this.$el,
    );
    this.$productAtcSuccessMessageVariantOptions = $(
      '[data-product-menu-addtocart-success-options]',
      this.$el,
    );

    this.revertToDefaultState = () => this._revertToDefaultState();
    this.changeToAddToCartState = () => this._changeState(this.states.addToCart);

    // Prime the variant data
    this._onVariantChange(this.form.variantHelper.getSelectedVariant());
    $(window).trigger('product-variant-switch.product-menu', {
      variant: this.form.variantHelper.getSelectedVariant(),
      product: this.data.product,
    });

    this._changeState(this.currentState);

    layout.onBreakpointChange(this.revertToDefaultState);
    this.dismissButton.addEventListener('click', this.revertToDefaultState);
    this.selectOptionsButton.addEventListener('click', this.changeToAddToCartState);
  }

  _changeState(state, animate = true) {
    $(window).off('touchstart.menu');
    $(window).off('touchend.menu touchcancel.menu');
    this.$el.off('touchstart.menu');
    this.$el.off('touchend.menu');

    const isDesktop = layout.isBreakpoint('L');

    if (animate) {
      let slideoutContent = this.el.querySelector(`[data-product-menu-slideout-state="${this.currentState}"]`);
      let $slideoutContent = $(slideoutContent);
      let shouldSlideoutAnimate = (
        $slideoutContent.length &&
        slideoutContent.hasAttribute('data-product-menu-slideout-no-animation')
      );

      this.$slideout.slideUp({
        duration: shouldSlideoutAnimate ? 0 : '',
        complete: () => {
          this.$slideout.removeClass('product-menu-slideout-visible');
          this.$slideout.css('display', '');

          this.currentState = state;
          this.el.setAttribute('data-product-menu-state', state);

          slideoutContent = this.el.querySelector(`[data-product-menu-slideout-state="${state}"]`);
          $slideoutContent = $(slideoutContent);

          if (!$slideoutContent.length) {
            return;
          }

          shouldSlideoutAnimate = slideoutContent.hasAttribute('data-product-menu-slideout-no-animation');
          const shouldShowSlideout = (
            (
              !isDesktop &&
              !slideoutContent.hasAttribute('data-product-menu-mobile-slideout-hidden')
            ) || (
              isDesktop &&
              !slideoutContent.hasAttribute('data-product-menu-desktop-slideout-hidden')
            )
          );

          if (shouldShowSlideout) {
            this.$slideout.slideDown({
              duration: shouldSlideoutAnimate ? 0 : '',
              start: () => {
                this.$slideout.css('display', '');
                this.$slideout.addClass('product-menu-slideout-visible');
              },
            });
          }
        },
      });
    } else {
      this.currentState = state;
      this.el.setAttribute('data-product-menu-state', state);
    }

    $(window).on('touchstart.menu', () => this._minimizeSlideout());
    $(window).on('touchend.menu touchcancel.menu', () => this._maximizeSlideout());
    this.$el.on('touchstart.menu', event => event.stopPropagation());
    this.$el.on('touchend.menu, ', event => event.stopPropagation());
  }

  _minimizeSlideout() {
    if (!$(`[data-product-menu-slideout-state="${this.currentState}"]`, this.el).length) {
      return;
    }

    const height = this.slideout.getBoundingClientRect().height;
    this.$slideout.animate({ height: height / 2, opacity: 0.2 }, { queue: false, duration: 500 });
  }

  _maximizeSlideout() {
    if (!$(`[data-product-menu-slideout-state="${this.currentState}"]`, this.el).length) {
      return;
    }

    const oldHeight = this.slideout.getBoundingClientRect().height;
    this.$slideout.css('height', '');

    const height = this.slideout.getBoundingClientRect().height;
    this.$slideout.css('height', oldHeight);

    this.$slideout.animate({ height, opacity: 1 }, { queue: false, duration: 500 });
  }

  _clearFailure() {
    clearTimeout(this.errorMessageTimeout);
    this.$productAtcFailureMessage.hide(0);
  }

  _revertToDefaultState() {
    this._changeState(layout.isBreakpoint('L') ? this.defaultDesktopState : this.defaultMobileState);
  }

  _onVariantChange(variant) {
    // ATC
    this.$el.find('[data-product-menu-button-addtocart]')
      .prop('disabled', !variant.available);

    // ATC text
    this.$el.find('[data-product-menu-button-addtocart-text]')
      .text(variant.available
        ? this.data.text.product_available
        : this.data.text.product_unavailable,
      );

    // Options
    this.form.variantHelper.$options
      .parent()
      .removeClass('option-soldout')
      .removeClass('option-selected')
      .addClass('option-disabled');

    this.form.variantHelper.$options.filter(':not(:disabled)')
      .parent()
      .removeClass('option-disabled');

    this.form.variantHelper.$options.filter('[data-soldout="true"]')
      .parent()
      .addClass('option-soldout');

    this.form.variantHelper.$options.filter(':checked')
      .parent()
      .addClass('option-selected');

    this._onQuantityChange(variant, this.form.quantity.value);
  }

  _onQuantityChange(variant, quantity) {
    const price = Shopify.formatMoney(variant.price * quantity, this.data.money_format);

    this.$productMenuButtonAddToCartPrice
      .text(price)
      .each((index, el) => CurrencyConverter.update(el));
  }

  _onAtcSuccess(response, quantity) {
    const productTitle = response.product_title;
    const options = response.variant_options.join(', ');

    this.$productAtcSuccessMessageVariantQuantity.text(quantity);
    this.$productAtcSuccessMessageProductTitle.text(productTitle);

    if (!this.form.variantHelper.isDefault()) {
      this.$productAtcSuccessMessageVariantOptions.text(options);
    }

    this.$productAtcFailureMessage.hide(0);
    this._changeState(this.states.addToCartSuccess);
  }

  _onAtcError(response, error) {
    this.$productAtcFailureMessage.html(error);

    if (this.form.variantHelper.isDefault()) {
      this.$productAtcFailureMessage.slideDown(0);
      this.$slideout.slideDown();
    } else {
      this.$productAtcFailureMessage.slideDown();
    }

    this.errorMessageTimeout = setTimeout(() => {
      if (this.form.variantHelper.isDefault()) {
        this.$slideout.slideUp({
          start: () => {
            this.$slideout.addClass('product-menu-slideout-visible');
            this.$slideout.css('display', '');
          },
          complete: () => this.$productAtcFailureMessage.slideUp(0),
        });
      } else {
        this.$productAtcFailureMessage.slideUp();
      }
    }, 5000);
  }

  unload() {
    $(window).off('touchstart.menu');
    $(window).off('touchend.menu touchcancel.menu');
    this.$el.off('touchstart.menu');
    this.$el.off('touchend.menu');
    layout.offBreakpointChange(this.revertToDefaultState);
    this.dismissButton.removeEventListener('click', this.revertToDefaultState);
    this.selectOptionsButton.removeEventListener('click', this.changeToAddToCartState);
    this.form.unload();
  }
}
